import type { IssueQuery } from '@/schemas/ipo'

/**
 * Query key factory.
 *
 * Separate page blocks have their own keys: an issue's detail changes when
 * SEBON extends a close, its peers when the market trades, and the table
 * when an issue is approved. Folding them together would refetch a
 * prospectus every time someone clicked the Rights tab. The table's key
 * carries the whole query, so a page-size change is its own cache entry.
 */
export const ipoKeys = {
  all: ['ipo'] as const,
  issuePages: () => [...ipoKeys.all, 'issues'] as const,
  issuePage: (query: IssueQuery) => [...ipoKeys.issuePages(), query] as const,
  currentPage: (query: Omit<IssueQuery, 'status'>) => [...ipoKeys.all, 'current', query] as const,
  issue: (key: string) => [...ipoKeys.all, 'issue', key] as const,
  peers: (key: string) => [...ipoKeys.all, 'peers', key] as const,
  list: () => [...ipoKeys.all, 'list'] as const,
}
